<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">
        
        <div class="form container px-2" v-if="candidate">

        <h5><b>E. &nbsp; &nbsp;CONFERENCES AND LEARNED SOCIETIES ACTIVITIES</b></h5>

        <!--conferences-->
        <div class="mb-4 text-start">
            <div class="d-flex mb-3 align-items-center">
                <b>
                    E.1 &nbsp; &nbsp;Conferences attended and paper read (but not included in C.6 above), with dates,
                    since joining this University:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#conference"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=conferences :type="'conferences'" />
        </div>



        <!-- conferences Modal -->
        <div class="modal fade" id="conference" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">Conference Attended</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3 mx-4 text-start">
                            <label for="exampleFormControlInput124" class="form-label me-3">Conference Details:</label>
                            <textarea rows="5" v-model="conference" type="text" class="form-control"
                                id="exampleFormControlInput4" placeholder="e.g. On 6 – 9 October, 2025, attended the 2025 Rivers State University Postgraduate International Annual Conference with the theme: Interdisciplinary Innovations: Bridging Knowledge for a Sustainable Future, organised by Rivers State University, Port Harcourt, Nigeria."></textarea>
                        </div>
                        <br>
                        <div class="text-start mx-4">
                            <label for="conferenceUrl" class="form-label">Certificate Google Drive Link:</label>
                            <input v-model="conferenceUrl" type="text" class="form-control" id="conferenceUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('conference')" type="button" class="btn btn-success"
                            data-bs-dismiss="modal">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--professional body-->
        <div class="mb-4 text-start">
            <div class="mb-3 d-flex">
                <b>
                    E.2 &nbsp; &nbsp;Active membership of relevant professional bodies:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#professionalBody"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=professionalBodies :type="'professionalBodies'" />
        </div>



        <!-- professional body Modal -->
        <div class="modal fade" id="professionalBody" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">Professional Body Membership</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3 mx-4 text-start">
                            <label for="exampleFormControlInput124" class="form-label me-3">Membership Details:</label>
                            <textarea rows="5" v-model="professionalBody" type="text" class="form-control"
                                id="exampleFormControlInput4" placeholder="e.g. Since 2024, Corporate Member of the Nigerian Society of Engineers (NSE)."></textarea>
                            <div>
                                <br>
                                <label for="professionalBodyUrl" class="form-label" style="font-size: 16px !important;">Google Drive Link:</label>
                                <input v-model="professionalBodyUrl" type="text" class="form-control" id="professionalBodyUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                                <br>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('professionalBody')" type="button" class="btn btn-success"
                            data-bs-dismiss="modal">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-row-reverse mb-5">
            <button @click="saveSection('next')" type="button" class="btn btn-success">Save & Continue</button>
            <button @click="saveSection('previous')" type="button" class="btn btn-success me-3">Previous Section</button>
        </div>
    </div>
    </div>
</Transition>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'sectionE',
    emits: ['toggleLoader', 'setSection', 'submitted'],
    data() {
        return { candidate: '',
            conference: '',
            conferences: [],
            conferenceUrl: '',
            professionalBody: '',
            professionalBodyUrl: '',
            professionalBodies: [],
            key: 0
        }
    },
    created() {
        this.$emit('setSection', 'Section E');
        this.setData()
    },
    methods: {
        resetEdit(){
            //removes edit section if present on the page
            for (var i=0; i < this.conferences.length; i++) {
                this.conferences[i].editing = false
            }
            for (var i=0; i < this.professionalBodies.length; i++) {
                this.professionalBodies[i].editing = false
            }
        },
        
        setDetails(candidate) {
            this.candidate = candidate;
            this.conferences = candidate.academicStaff.conferences ? candidate.academicStaff.conferences : [];
            this.professionalBodies = candidate.professionalBodies ? candidate.professionalBodies : [];
        },
        async saveSection(page) {
            this.$emit('toggleLoader');

            var dataDetails = {
                conferences: this.conferences,
                professionalBodies: this.professionalBodies
            }

            const candidate = await DataService.saveData(dataDetails);

            if (candidate) {
                this.setDetails(candidate)
                if (page == 'previous') {
                    this.$router.push('/sectiond')
                } else if (page == 'next') {
                    this.$router.push('/sectionf')
                }
            }

            this.$emit('toggleLoader');
        },
        async setData() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id, 'sectionE');

            if (candidate) { 
                if ((candidate.staffType == "Junior Non-academic") || (candidate.staffType == "Senior Non-academic")) {
                    this.$emit('toggleLoader');
                    this.$router.push({ path: `/section1` });
                    return
                }
                this.$emit('submitted', candidate.submitted);
                this.setDetails(candidate)
            }

            this.$emit('toggleLoader');
        },
        joinDetails(category) {
            if (category == 'conference' && this.conference) {
                this.conferences.unshift({ data: this.conference, fileUrl: !/^https?:\/\//i.test(this.conferenceUrl) ? this.conferenceUrl ? "https://" + this.conferenceUrl : '' : this.conferenceUrl });
                this.conference = '';
            } else if (category == 'professionalBody' && this.professionalBody) {
                this.professionalBodies.unshift({ data: this.professionalBody, fileUrl: !/^https?:\/\//i.test(this.professionalBodyUrl) ? this.professionalBodyUrl ? "https://" + this.professionalBodyUrl : '' : this.professionalBodyUrl });
                this.professionalBody = '';
                this.professionalBodyUrl = ''
            }
            this.key += 1
        }
    }
}
</script>